import React, { Component } from 'react';
import { Localized } from '@fluent/react';
import { Card, CardHeader, CardBody, Row, Button } from 'reactstrap';
import {
  addAdversary,
  getAdversaries,
  updateAdversary,
} from '../../dbAdversary';
import postTranslations from '../../controllers/postTranslation';
import { ReactComponent as Globe } from '../../assets/globe-alt.svg';

export default class AdversaryDetails extends Component {
  state = {
    translateLoading: false,
    adversaryTranslatedTitle: '',
    adversaryTranslatedText: '',
    adversariesCached: [],
    clickedShowOriginal: false,
    clickedTranslate: false,
  };

  populateAdversaries = () => {
    const { id } = this.props;
    const result = getAdversaries();
    result.then(data => this.setState({ adversariesCached: data }));
    result.then(data => {
      if (data.length > 0) {
        const filteredAdversary =
          data.length > 0 && data.filter(item => item.idAdversary === id)[0];
        this.setState({
          adversaryTranslatedTitle: filteredAdversary?.title,
        });
        this.setState({
          adversaryTranslatedText: filteredAdversary?.text,
        });
      }
    });
  };

  compareUpdateDate = () => {
    const { date, id } = this.props;
    const result = getAdversaries();
    result.then(data => {
      if (data.length > 0) {
        const filteredAdversary =
          data.length > 0 && data.filter(item => item.idAdversary === id)[0];
        const dateFiltered = Math.floor(
          new Date(filteredAdversary?.updateDate).getTime() / 1000
        );
        const adversaryDate = Math.floor(new Date(date).getTime() / 1000);
        if (dateFiltered !== adversaryDate && !isNaN(adversaryDate)) {
          this.getTranslactionsUpdate();
        }
      }
    });
  };

  getTranslactions = () => {
    const { title, content, id, date } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const adversaryToTranslate = {
      title: title?.rendered,
      text: content?.rendered,
    };
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        { title: adversaryToTranslate.title, text: adversaryToTranslate.text },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            adversaryTranslatedTitle: adversaryToTranslate.title,
          });
          this.setState({
            adversaryTranslatedText: adversaryToTranslate.text,
          });

          this.setState({ translateLoading: false });
        } else {
          addAdversary({
            title: res?.translation?.title,
            text: res?.translation?.text,
            idAdversary: id,
            updateDate: date,
          });
          this.populateAdversaries();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  getTranslactionsUpdate = () => {
    const { title, content, id, date } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang.split('-')[0];
    const adversaryToTranslate = {
      title: title?.rendered,
      text: content?.rendered,
    };
    if (lang !== 'it-IT') {
      this.setState({ translateLoading: true });
      postTranslations(
        { title: adversaryToTranslate.title, text: adversaryToTranslate.text },
        language
      ).then(res => {
        if (
          !res ||
          (res && res.ok === false) ||
          (res && res?.status >= 400 && res?.status < 600)
        ) {
          this.setState({
            adversaryTranslatedTitle: adversaryToTranslate.title,
          });
          this.setState({
            adversaryTranslatedText: adversaryToTranslate.text,
          });
          this.setState({ translateLoading: false });
        } else {
          updateAdversary(id, {
            title: res?.translation?.title,
            text: res?.translation?.text,
            idAdversary: id,
            updateDate: date,
          });
          this.populateAdversaries();
          this.setState({ translateLoading: false });
        }
      });
    }
  };

  componentDidMount() {
    const lang = localStorage.getItem('language');
    if (lang !== 'it-IT') {
      const { id, date } = this.props;
      const result = getAdversaries();
      result.then(data => {
        if (data.length > 0) {
          const filteredAdversary =
            data.length > 0 && data.filter(item => item.idAdversary === id)[0];
          if (!filteredAdversary) {
            this.getTranslactions();
          } else {
            const dateFiltered = Math.floor(
              new Date(filteredAdversary.updateDate).getTime() / 1000
            );
            const adversaryDate = Math.floor(new Date(date).getTime() / 1000);
            if (dateFiltered !== adversaryDate) {
              this.getTranslactionsUpdate();
            }
          }
          if (filteredAdversary) {
            this.setState({
              adversaryTranslatedTitle: filteredAdversary?.title,
            });
            this.setState({
              adversaryTranslatedText: filteredAdversary?.text,
            });
          }
        } else {
          this.getTranslactions();
        }
      });
    }
  }

  showOriginal = () => {
    const { title, content } = this.props;
    this.setState({
      adversaryTranslatedTitle: title?.rendered,
    });
    this.setState({
      adversaryTranslatedText: content?.rendered,
    });
    this.setState({ clickedShowOriginal: true });
    this.setState({ clickedTranslate: false });
  };

  translateAdversary = () => {
    this.setState({ clickedShowOriginal: false });
    this.setState({ clickedTranslate: true });
    const { id, title, content, date } = this.props;
    const lang = localStorage.getItem('language');
    const language = lang === 'it-IT' ? 'en' : lang.split('-')[0];
    const adversaryToTranslate = {
      title: title?.rendered,
      text: content?.rendered,
    };
    const result = getAdversaries();
    result.then(data => {
      if (data.length > 0) {
        const filteredAdversary =
          data.length > 0 && data.filter(item => item.idAdversary === id)[0];
        if (id !== filteredAdversary?.idAdversary) {
          this.setState({ translateLoading: true });
          postTranslations(
            {
              title: adversaryToTranslate.title,
              text: adversaryToTranslate.text,
            },
            language
          ).then(res => {
            if (
              !res ||
              (res && res.ok === false) ||
              (res && res?.status >= 400 && res?.status < 600)
            ) {
              this.setState({
                adversaryTranslatedTitle: adversaryToTranslate.title,
              });
              this.setState({
                adversaryTranslatedText: adversaryToTranslate.text,
              });
              this.setState({ translateLoading: false });
            } else {
              addAdversary({
                title: res?.translation?.title,
                text: res?.translation?.text,
                idAdversary: id,
                updateDate: date,
              });
              this.populateAdversaries();
              this.setState({ translateLoading: false });
            }
          });
        } else {
          const dateFiltered = Math.floor(
            new Date(filteredAdversary?.updateDate).getTime() / 1000
          );
          const adversaryDate = Math.floor(new Date(date).getTime() / 1000);
          if (dateFiltered !== adversaryDate) {
            this.setState({ translateLoading: true });
            postTranslations(
              { title: adversaryDate.title, text: adversaryToTranslate.text },
              language
            ).then(res => {
              if (
                !res ||
                (res && res.ok === false) ||
                (res && res?.status >= 400 && res?.status < 600)
              ) {
                this.setState({
                  adversaryTranslatedTitle: adversaryToTranslate.title,
                });
                this.setState({
                  adversaryTranslatedText: adversaryToTranslate.text,
                });
                this.setState({ translateLoading: false });
              } else {
                updateAdversary(id, {
                  title: res?.translation?.title,
                  text: res?.translation?.text,
                  idAdversary: id,
                  updateDate: date,
                });
                this.populateReports();
                this.setState({ translateLoading: false });
              }
            });
          } else {
            this.setState({
              adversaryTranslatedTitle: filteredAdversary?.title,
            });
            this.setState({
              adversaryTranslatedText: filteredAdversary?.text,
            });
          }
        }
      } else {
        this.setState({ translateLoading: true });
        postTranslations(
          {
            title: adversaryToTranslate.title,
            text: adversaryToTranslate.text,
          },
          language
        ).then(res => {
          if (
            !res ||
            (res && res.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              adversaryTranslatedTitle: adversaryToTranslate.title,
            });
            this.setState({
              adversaryTranslatedText: adversaryToTranslate.text,
            });
            this.setState({ translateLoading: false });
          } else {
            addAdversary({
              title: res?.translation?.title,
              text: res?.translation?.text,
              idAdversary: id,
              updateDate: date,
            });
            this.populateAdversaries();
            this.setState({ translateLoading: false });
          }
        });
      }
    });
  };

  render() {
    const { title, content, flag, featured_image, adversary_area } = this.props;
    const {
      adversaryTranslatedText,
      adversaryTranslatedTitle,
      translateLoading,
      clickedShowOriginal,
      clickedTranslate,
    } = this.state;
    const lang = localStorage.getItem('language');
    return (
      <Card className="mb-4">
        <CardHeader className="headerWrapper">
          <h2>
            <i className="fa fa-bolt ts-blue2" aria-hidden="true" />{' '}
            <span className="ts-blue2">
              <Localized id="insight">insight</Localized> /
            </span>{' '}
            <Localized id="adversaries">adversaries</Localized>
          </h2>
          <div className="reportHeader">
            {translateLoading ? (
              <div className="translatingText">translating...</div>
            ) : (lang !== 'it-IT' && !clickedShowOriginal) ||
              clickedTranslate ? (
              <Button
                color="primary"
                className="reportButton"
                onClick={this.showOriginal}
              >
                <Globe className="imgReportButton" />
                <Localized id="report_detail_show_original">
                  report_detail_show_original
                </Localized>
              </Button>
            ) : (
              <Button
                color="primary"
                className="reportButton"
                onClick={this.translateAdversary}
              >
                <Globe className="imgReportButton" />
                <Localized id="report_detail_translate_btn">
                  report_detail_translate_btn
                </Localized>
              </Button>
            )}
          </div>
        </CardHeader>
        <CardBody>
          <ul className="list-unstyled">
            <li className="media">
              <Row>
                <div className="col-12 avatar-wrapper">
                  <img
                    src={
                      featured_image ? featured_image : `/img/flags/${flag}.png`
                    }
                    className="img-avatar img-fluid"
                    alt="Flag"
                  />
                </div>
                <div className="media-body col-12">
                  <h3 className="mt-0 mb-1">
                    {(lang === 'it-IT' && !clickedTranslate) || translateLoading
                      ? title.rendered
                      : adversaryTranslatedTitle}
                  </h3>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        (lang === 'it-IT' && !clickedTranslate) ||
                        translateLoading
                          ? content.rendered
                          : adversaryTranslatedText,
                    }}
                  />
                </div>
              </Row>
            </li>
            <li className="media">
              <div className="report-tags">
                {adversary_area.map(a => (
                  <span
                    key={a.id}
                    className="badge report-tag"
                    dangerouslySetInnerHTML={{ __html: a.name }}
                  />
                ))}
              </div>
            </li>
          </ul>
        </CardBody>
      </Card>
    );
  }
}
